<template>
	<div class="row">
		<div class="col-12 col-lg-4">

			<h6 class="text-uppercase text-muted">Filename/Version</h6>
			<div v-if="creativeAsset.media_visible_to_client.length" class="dropdown mb-4">
				<a class="py-3 btn btn-white dropdown-toggle text-start d-flex align-items-center" href="#" role="button" data-bs-toggle="dropdown">
					<div>{{ strLimit(selectedMedia.original_name, 20) }}</div>
					<div class="badge bg-light mb-n1 ms-auto">
						v{{ selectedMedia.version }}
					</div>
				</a>
				<div class="dropdown-menu w-100 bg-lighter">
					<h6 class="dropdown-header">Versions</h6>
					<a v-for="(version, index) in creativeAsset.media_visible_to_client"
						href="#"
						@click.prevent="selectedMedia = version"
						:class="selectedMedia.id == version.id
							? 'dropdown-item py-3 active bg-white w-100 d-flex align-items-center'
							: 'dropdown-item py-3 w-100 d-flex align-items-center'">
						{{ strLimit(version.original_name, 20) }}
						<span class="badge bg-light ms-auto">
							v{{ version.version }}
						</span>
					</a>
				</div>
			</div><!--/.dropdown-->
			<div v-else class="d-flex align-items-center">
				<div class="fw-bold">{{ selectedMedia.original_name }}</div>
				<div class="badge bg-light ms-2">v{{ selectedMedia.version }}</div>
			</div>

			<div v-if="selectedMedia.uploader">
				<h6 class="text-uppercase text-muted">Uploaded</h6>
				<p class="small mb-4">
					{{ formatDate(selectedMedia.created_at) }}
					by {{ selectedMedia.uploader.name }}
				</p>
			</div>

			<div v-if="selectedMedia.width">
				<h6 class="text-uppercase text-muted">Dimensions</h6>
				<p class="small mb-4">
					<span v-if="Math.abs(selectedMedia.video_rotation) == 90">
						{{ selectedMedia.height }} x {{ selectedMedia.width }}
					</span>
					<span v-else>
						{{ selectedMedia.width }} x {{ selectedMedia.height }}
					</span>
				</p>
			</div>

			<h6 class="text-uppercase text-muted">Approval</h6>
			<p class="small mb-4">
				<div v-if="creativeAsset.approved_media.length">
					<a @click.prevent="unapprove" class="btn btn-success ps-3 pe-4 rounded-pill" href="#">
						<i class="fe fe-check-circle ms-1 me-2"></i> Approved
					</a>
				</div>
				<div v-else>
					<a @click.prevent="approve" class="btn btn-outline-success ps-3 pe-4 rounded-pill" href="#">
						<i class="fe fe-circle me-1 ms-2"></i> Approve
					</a>
				</div>
			</p>

		</div>

		<div class="col-12 col-lg-8">

			<!-- Card -->
			<div class="card">
				<div class="card-body">

					<!-- Media -->
					<div v-if="isEmbeddableImage">
						<div class="mb-3 bg-secondary rounded ratio ratio-1x1">
							<a class="w-100 h-100" @click.prevent="openImageLightbox('#media')" href="#">

								<img :src="selectedMedia.embeddable.url"
									:class="selectedMedia.embeddable.width >= selectedMedia.embeddable.height
										? 'position-absolute w-100 h-auto top-50 start-50 translate-middle'
										: 'position-absolute h-100 w-auto top-50 start-50 translate-middle'"
									id="media">

							</a>
						</div>
					</div>

					<div v-else-if="isEmbeddableVideo && selectedMedia.poster">
						<div class="mb-3 bg-secondary rounded ratio ratio-1x1">
							<a class="w-100 h-100" @click.prevent="openVideoLightbox('#media')" href="#">

								<img :src="selectedMedia.poster.url" id="media"
									:class="selectedMedia.poster.width >= selectedMedia.poster.height
										? 'position-absolute w-100 h-auto top-50 start-50 translate-middle'
										: 'position-absolute h-100 w-auto top-50 start-50 translate-middle'">

								<img src="/img/play-overlay.png" style="width:20%;height:auto;"
									class="position-absolute top-50 start-50 translate-middle">

							</a>
						</div>
					</div>

					<div v-else-if="isEmbeddableVideo && !selectedMedia.poster">
						<div class="mb-3 text-center ratio ratio-1x1 bg-secondary rounded">
							<a class="w-100 h-100" @click.prevent="openVideoLightbox('#media')" href="#">

								<img src="/img/play-overlay.png" id="media" style="width:20%;height:auto;"
									class="position-absolute top-50 start-50 translate-middle">

							</a>
						</div>
					</div>

					<div v-else-if="selectedMedia.aggregate_type == 'audio'">
						<div class="mb-3 text-center ratio ratio-1x1 bg-secondary rounded">
							<div class="d-flex flex-column align-items-center justify-content-center">
								<div class="text-white mb-3"><i class="fe fe-music"></i></div>
								<div class="fw-bold text-white">Audio</div>
							</div>
						</div>
					</div>

					<div v-else-if="selectedMedia.processing_job_status == 'failed'">
						<div class="mb-3 text-center ratio ratio-1x1 bg-secondary rounded">
							<div class="d-flex flex-column align-items-center justify-content-center">
								<div class="text-white mb-3"><i class="fe fe-eye-off"></i></div>
								<div class="fw-bold text-white">Could not create embeddable media</div>
							</div>
						</div>
					</div>

					<div v-else>
						<div class="mb-3 text-center ratio ratio-1x1 bg-secondary rounded">
							<div class="d-flex flex-column align-items-center justify-content-center">
								<div class="spinner-border text-white mb-3" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
								<div class="fw-bold text-white">Processing media...</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col">
							<a :href="this.creativeAssetEndpoint + '/media/' + this.selectedMedia.id + '/download'" class="btn btn-lg btn-white w-100 rounded-pill">
								<i class="fe fe-download me-1"></i>
								Download Original <span class="text-muted">({{ formatBytes(selectedMedia.size) }})</span>
							</a>
						</div>
					</div><!--/.row-->

					<div v-if="creativeAsset.title || creativeAsset.caption">

						<div class="row">
							<div class="col">
								<hr class="my-4">
							</div>
						</div>

						<div class="row">
							<div class="col">
								<div v-if="creativeAsset.title" class="h3">
									{{ creativeAsset.title }}
								</div>
								<div v-if="creativeAsset.caption"
									class="text-secondary"
									v-html="nl2br(linkify(creativeAsset.caption))"
								></div>
							</div><!--/.col-->
						</div><!--/.row-->

						<div class="row">
							<div class="col">
								<hr class="my-4">
							</div>
						</div>

					</div><!--/v-if-->

					<client-deliverable-creative-asset-comments
						:creative-asset-data="creativeAsset"
						:creative-asset-endpoint="creativeAssetEndpoint"
					></client-deliverable-creative-asset-comments>

				</div><!--/.card-body-->
			</div><!--/.card-->

		</div><!--/.col-->
	</div><!--/.row-->


	<div class="row">
		<div class="col-12">
			<hr class="my-5">
		</div>
	</div><!--/.row-->
</template>

<script>
	import BigPicture from 'bigpicture';

	import ClientDeliverableCreativeAssetComments from './ClientDeliverableCreativeAssetComments.vue';
	// import ButtonToggleApproved from '../ButtonToggleApproved.vue';

	import dayjs from 'dayjs';

	export default {

		props: ['deliverableData', 'creativeAssetData', 'creativeAssetEndpoint'],

		components: {
			'client-deliverable-creative-asset-comments': ClientDeliverableCreativeAssetComments
			// 'button-toggle-approved': ButtonToggleApproved
		},

		data() {
			return {
				deliverable: this.deliverableData,
				creativeAsset: this.creativeAssetData,
				selectedMedia: this.creativeAssetData.media_visible_to_client[0]
			}
		},

		mounted() {

		},

		computed: {

			isEmbeddableVideo() {
				if(this.selectedMedia.aggregate_type == 'video' && this.selectedMedia.embeddable) {
					return true;
				}
				return false;
			},

			isEmbeddableImage() {
				if(this.selectedMedia.aggregate_type == 'image' && this.selectedMedia.embeddable) {
					return true;
				}
				return false;
			},

		},

		methods: {

			approve() {
				axios.get(this.creativeAssetEndpoint + '/media/' + this.selectedMedia.id + '/approve')
					.then((response) => {
						this.selectedMedia.approved_at = dayjs();
						this.creativeAsset.approved_media.push(this.selectedMedia);
					})
					.catch((error) => {
						console.error(error);
					});
			},

			unapprove() {
				axios.get(this.creativeAssetEndpoint + '/unapprove')
					.then((response) => {

						this.creativeAsset.approved_media = [];
						this.selectedMedia.approved_at = null;

						// reset approved_at for all media associated with the creative asset
						for(let i = 0; i < this.creativeAsset.media_visible_to_client.length; i++) {
							this.creativeAsset.media_visible_to_client[i].approved_at = null;
						}

					})
					.catch((error) => {
						console.error(error);
					});
			},

			// toggleApproved() {
			// 	axios.get(this.creativeAssetEndpoint + '/media/' + this.selectedMedia.id + '/toggle-approved')
			// 		.then((response) => {
			// 			if(this.selectedMedia.approved_at != null) {
			// 				this.selectedMedia.approved_at = null;
			// 			}
			// 			else {
			// 				this.selectedMedia.approved_at = dayjs();
			// 			}
			// 		})
			// 		.catch((error) => {
			// 			console.error(error);
			// 		});
			// },

			openImageLightbox(el) {
				BigPicture({
					el: document.querySelector(el),
					imgSrc: this.selectedMedia.embeddable.url,
					noLoader: true,
				});
			},

			openVideoLightbox(el) {
				BigPicture({
					el: document.querySelector(el),
					vidSrc: this.selectedMedia.embeddable.url,
					noLoader: true,
				});
			},

			formatDate(date) {
				return dayjs(date).format('MMM D, YYYY h:mma');
			},

			formatBytes(bytes, decimals = 0) {
				if (bytes === 0) return '0 bytes';
				const k = 1024;
				const dm = decimals < 0 ? 0 : decimals;
				const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];
				const i = Math.floor(Math.log(bytes) / Math.log(k));
				return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
			},

			isLowRes(width, height) {
				if(width > 0 && height > 0 && (width * height < 1920 * 1080)) {
					return true;
				}
				else {
					return false;
				}
			},

			nl2br(str, is_xhtml) {
				var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />'   : '<br>';
				return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag   + '$2');
			},

			linkify(text) {
				var urlRegex = /(https?:\/\/[^\s]+)/g;
				return text.replace(urlRegex, function(url) {
					return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
				});
			},

			strLimit(str, length) {
				if(str.length <= length) {
					return str;
				}

				return str.substring(0, length) + "...";
			}

		},

	}

</script>
